import { Pill } from "src/base-components/Pill";
import { Tooltip } from "src/design-system/Tooltip";

export const EnumValuesTooltip: React.FC<{
  enumValues: unknown[];
  children?: React.ReactNode;
}> = ({ enumValues, children }) => {
  if (!children) {
    return null;
  }
  const renderBody = () => {
    return (
      <div className="flex flex-wrap gap-1">
        {enumValues.map((value, index) => (
          <Pill
            fontType="code"
            key={`${String(value)}-${index}`}
            size="sm"
            variant="dark-gray"
          >
            <Pill.Text>{String(value)}</Pill.Text>
          </Pill>
        ))}
      </div>
    );
  };
  return (
    <Tooltip body={renderBody()} placement="right" title="Enum values">
      {children}
    </Tooltip>
  );
};
